import { Body, MaterialUICore, axiomTokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { color } = axiomTokens;

export const Text = styled(Body)({
  whiteSpace: 'pre-line',
  color: color.typeface.smooth,
});
